/* BEYOND theme JS */
(function () {
  'use strict';
  var B = window.BEYOND || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Sale window + countdowns ---------- */
  function parseDate(s) { var d = new Date(s); return isNaN(d) ? null : d; }
  var saleStart = B.sale && parseDate(B.sale.start);
  var saleEnd = B.sale && parseDate(B.sale.end);

  function saleState(now) {
    if (!B.sale || !B.sale.enabled || !saleStart || !saleEnd) return 'off';
    if (now < saleStart) return 'upcoming';
    if (now <= saleEnd) return 'live';
    return 'ended';
  }

  function applyDropLinks(st) {
    var pre = st === 'upcoming';
    $$('[data-drop]').forEach(function (el) {
      el.setAttribute('href', pre ? el.dataset.dropPre : el.dataset.dropHref);
    });
    $$('[data-drop-label]').forEach(function (el) {
      if (el.dataset.launchLabel == null) el.dataset.launchLabel = el.textContent;
      var t = pre && B.sale && B.sale.dropLabel ? B.sale.dropLabel : el.dataset.launchLabel;
      if (el.textContent !== t) el.textContent = t;
    });
  }

  function applySaleWindow() {
    var st = saleState(new Date());
    applyDropLinks(st);
    $$('[data-sale-window]').forEach(function (el) {
      var ok = st === 'live' || (st === 'upcoming' && el.hasAttribute('data-sale-upcoming-ok'));
      el.hidden = !ok;
    });
    return st;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tickCountdowns() {
    var now = new Date();
    var st = applySaleWindow();
    $$('[data-countdown]').forEach(function (el) {
      var start = parseDate(el.dataset.start), end = parseDate(el.dataset.end);
      if (!start || !end || st === 'off' || st === 'ended') { el.hidden = true; return; }
      var target = st === 'upcoming' ? start : end;
      var diff = Math.max(0, target - now);
      el.hidden = false;
      el.classList.toggle('is-live', st === 'live');
      var label = $('[data-countdown-label]', el);
      if (label) label.textContent = st === 'live' ? 'Sale ends in' : 'Sale starts in';
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      var map = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
      $$('[data-cd]', el).forEach(function (u) { u.textContent = map[u.dataset.cd]; });
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var panel = $('[data-search-panel]', header);
    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        header.classList.add('is-scrolled');
        if (!panel.hidden) $('input[type=search]', panel).focus();
      });
    });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { panel.hidden = true; }); });
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = $('button, a, input', $('.drawer__panel', d));
    if (f) setTimeout(function () { f.focus(); }, 50);
    return true;
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      if (openDrawer(open.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeLightbox(); closeModals(); }
  });

  /* ---------- Modals ---------- */
  function closeModals() { $$('[data-modal]').forEach(function (m) { m.hidden = true; }); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) { var m = $('[data-modal="' + o.dataset.modalOpen + '"]'); if (m) m.hidden = false; return; }
    if (e.target.closest('[data-modal-close]')) closeModals();
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function refreshDrawer(open) {
    var drawer = $('#CartDrawer');
    var url = (B.routes && B.routes.root ? B.routes.root.replace(/\/$/, '') : '') + '/?sections=cart-drawer';
    return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      if (drawer && data['cart-drawer']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var fresh = tmp.querySelector('#CartDrawer');
        if (fresh) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen || open) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
          applySaleWindow();
        }
      }
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) { updateCount(cart.item_count); });
  }

  function changeLine(line, qty) {
    var drawer = $('#CartDrawer');
    if (drawer) drawer.classList.add('is-loading');
    return fetch((B.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshDrawer(false);
    }).finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    var li = b.closest('[data-line]');
    changeLine(parseInt(li.dataset.line, 10), parseInt(b.dataset.lineQty, 10));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-input]')) return;
    var li = e.target.closest('[data-line]');
    changeLine(parseInt(li.dataset.line, 10), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root);
    var addLabel = $('[data-add-label]', root);
    var priceBox = $('[data-pdp-price]', root);
    var errorBox = $('[data-form-error]', root);
    var isPre = (product.tags || []).some(function (t) { return /^pre-?order$/i.test(t); });
    var money = function (cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
      try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur }).format(cents / 100) + ' ' + cur; }
      catch (err) { return '$' + (cents / 100).toFixed(2); }
    };

    function selected() {
      return $$('[data-option-index]:checked', root).sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; }).map(function (i) { return i.value; });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      $$('[data-option-index]', root).forEach(function (input) {
        var idx = +input.dataset.optionIndex;
        var test = opts.slice(); test[idx] = input.value;
        var v = findVariant(test);
        input.closest('.pill').classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function update() {
      var opts = selected();
      opts.forEach(function (val, i) { var l = $('[data-option-value="' + i + '"]', root); if (l) l.textContent = val; });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? (isPre ? 'Pre-order now' : 'Add to cart') : 'Sold out';
      if (priceBox) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceBox.innerHTML = '<div class="price price--large' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + money(v.price) + '</span>' +
          (sale ? '<s class="price__was">' + money(v.compare_at_price) + '</s><span class="price__off">-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>' : '') + '</div>';
      }
      var hh = $('[data-hh-match]', root);
      if (hh && hh.dataset.hhMatch) { var note = $('[data-hh-note]', hh); if (note) note.hidden = (v.title || '').toLowerCase().indexOf(hh.dataset.hhMatch) !== -1; }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      if (v.featured_media) {
        var slide = $('[data-media-id="' + v.featured_media.id + '"]', root);
        var wrap = $('[data-pdp-slides]', root);
        if (slide && wrap) {
          if (window.innerWidth < 990) wrap.scrollTo({ left: slide.offsetLeft - wrap.offsetLeft, behavior: 'smooth' });
          else if (slide !== wrap.firstElementChild) { wrap.insertBefore(slide, wrap.firstElementChild); }
        }
      }
    }
    $$('[data-option-index]', root).forEach(function (i) { i.addEventListener('change', update); });
    if ($('[data-option-index]', root)) markAvailability(selected());

    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="quantity"]', root);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });

    if (form && B.cartType === 'drawer') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.classList.add('is-loading'); addBtn.disabled = true; errorBox.hidden = true;
        fetch((B.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { errorBox.textContent = res.j.description || res.j.message || 'Could not add to cart.'; errorBox.hidden = false; return; }
            return refreshDrawer(true).then(function () { openDrawer('cart'); });
          })
          .catch(function () { form.submit(); })
          .finally(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = false; });
      });
    }

    var thumbs = $('[data-pdp-thumbs]', root), slides = $('[data-pdp-slides]', root);
    if (thumbs && slides) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]'); if (!t) return;
        var s = slides.children[+t.dataset.thumb];
        slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      });
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        $$('[data-thumb]', thumbs).forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }
  }

  /* ---------- Before / after ---------- */
  function initCompare() {
    $$('[data-compare]').forEach(function (c) {
      if (c.dataset.bound) return; c.dataset.bound = '1';
      var r = $('[data-compare-range]', c);
      var set = function () { c.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
      // gentle hint animation the first time it's seen
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var io = new IntersectionObserver(function (ents) {
        if (!ents[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t; var p = (t - t0) / 1600; if (p > 1) p = 1;
          r.value = 50 + Math.sin(p * Math.PI * 2) * 22; set();
          if (p < 1) requestAnimationFrame(step); else { r.value = 50; set(); }
        }
        requestAnimationFrame(step);
      }, { threshold: .6 });
      io.observe(c);
    });
  }

  /* ---------- Gallery + lightbox ---------- */
  var lb = null, lbItems = [], lbIndex = 0;
  function renderLightbox() {
    var it = lbItems[lbIndex]; if (!it) return;
    var stage = $('[data-lightbox-stage]', lb);
    stage.innerHTML = it.dataset.type === 'video'
      ? '<video src="' + it.dataset.src + '" controls autoplay playsinline></video>'
      : '<img src="' + it.dataset.src + '" alt="">';
  }
  function openLightbox(item) {
    lb = $('[data-lightbox]'); if (!lb) return;
    var scope = item.closest('[data-gallery], [data-product]') || document;
    lbItems = $$('[data-lightbox-item]', scope);
    lbIndex = Math.max(0, lbItems.indexOf(item));
    renderLightbox(); lb.hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lb || lb.hidden) return;
    lb.hidden = true; $('[data-lightbox-stage]', lb).innerHTML = ''; document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var it = e.target.closest('[data-lightbox-item]');
    if (it) { e.preventDefault(); openLightbox(it); return; }
    if (!lb || lb.hidden) return;
    if (e.target.closest('[data-lightbox-close]') || e.target === lb) closeLightbox();
    else if (e.target.closest('[data-lightbox-next]')) { lbIndex = (lbIndex + 1) % lbItems.length; renderLightbox(); }
    else if (e.target.closest('[data-lightbox-prev]')) { lbIndex = (lbIndex - 1 + lbItems.length) % lbItems.length; renderLightbox(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % lbItems.length; renderLightbox(); }
    if (e.key === 'ArrowLeft') { lbIndex = (lbIndex - 1 + lbItems.length) % lbItems.length; renderLightbox(); }
  });
  function initGalleries() {
    $$('[data-gallery]').forEach(function (g) {
      if (g.dataset.bound) return; g.dataset.bound = '1';
      var track = $('[data-gallery-track]', g);
      var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.7, behavior: 'smooth' }); };
      var n = $('[data-gallery-next]', g), p = $('[data-gallery-prev]', g);
      if (n) n.addEventListener('click', function () { step(1); });
      if (p) p.addEventListener('click', function () { step(-1); });
      // drag to scroll on desktop
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
      window.addEventListener('pointerup', function () { down = false; track.style.scrollSnapType = ''; });
      track.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - sx;
        if (Math.abs(dx) > 5) { moved = true; track.style.scrollSnapType = 'none'; }
        track.scrollLeft = sl - dx;
      });
      track.addEventListener('click', function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var form = $('[data-filter-form]'); if (!form) return;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-filter-input]')) return;
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      window.location.search = params.toString();
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    $$('[data-recs]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recs]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; observeReveals(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;
  function observeReveals(scope) {
    $$('.reveal:not(.is-in)', scope).forEach(function (el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------- Mobile-only hero video ---------- */
  function initMobVideo() {
    $$('[data-mob-video]').forEach(function (v) {
      if (v.dataset.bound) return;
      var mq = window.matchMedia('(max-width: 749px)');
      var load = function () {
        if (!mq.matches || v.dataset.bound) return;
        v.dataset.bound = '1'; v.src = v.dataset.src; v.load();
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      };
      load();
      if (mq.addEventListener) mq.addEventListener('change', load);
    });
  }

  /* ---------- Gallery videos: play when on screen ---------- */
  function initGalleryVideos() {
    var vids = $$('[data-gal-video]');
    if (!vids.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (!v.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: .25 }) : null;
    vids.forEach(function (v) { if (io) io.observe(v); else { v.src = v.dataset.src; } });
  }

  /* ---------- Boot ---------- */
  function init() {
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
    initHeader();
    $$('[data-product]').forEach(initProduct);
    initCompare();
    initGalleries();
    initFilters();
    initRecs();
    initMobVideo();
    initGalleryVideos();
    observeReveals(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('[data-product]', s).forEach(initProduct);
    initCompare(); initGalleries(); observeReveals(s); tickCountdowns();
    $$('.reveal', s).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
